// 戴冠獣の8コマの歩き (2026-11-04・配布版の既定)。前の2枚の歩き (walk_passing ↔ walk_reach) は開発版 ?houndWalk=2 で比べる。
//   作者の答え: 8コマで ok・歩く速さは slow (db answers/hound-walk-8f-1104)。速さは bosses.ts の dream-hound walkSpeedMul 0.75。
//   作者の答え: 骨格を直した模型を slow で (db answers/hound-walk-skeleton-1104)・型の1枚 t125 の描き方で ok (db answers/hound-walk-art-1104)。
//   絵 = 模型 hound-walk-real-slow (src/boss_mockup/moves/hound_walk.ts) の1周を 0.125 秒おきに Codex が描いた8枚。
//   記録 = docs/research/2026-11-04-hound-walk-8frames.md
//   大きさ・横の置き場所・1周の距離は絵から測った値 (sprites.ts の POSE_SCALE_FIX・HOUND_PASS_ANCHOR_X・下の STRIDE)。
//   tests/hound_walk8_1104.test.ts が「床に着いた足がコマの切り替えで滑らない」と「待機⇔歩きで体が跳ばない」を見る。
import { setSpriteFileOverride, setWalkCycleOverride, type WalkCycleSmooth } from './sprites'
import type { SpriteKey } from './types'

export const HOUND_WALK8_KEYS: readonly SpriteKey[] = [
  'houndWalk8_t000', 'houndWalk8_t125', 'houndWalk8_t250', 'houndWalk8_t375',
  'houndWalk8_t500', 'houndWalk8_t625', 'houndWalk8_t750', 'houndWalk8_t875',
]

/** 1周 (8コマ) で進む画面 px。床に着いた足がコマの間で動かない距離 (絵から解いた値)。 */
//   = 8コマ × 1コマで足が進む 112.2 原画px × 待機の縮尺 0.2011 (= 186 × 0.89 ÷ √677797)。
export const HOUND_WALK8_STRIDE_PX = 180.5

let on = false
// カクつきの直し方の比べ物 (2026-11-04・開発版 ?houndWalkFix=lock|fade)。配布版は無し (= 体と一緒に絵が滑る今の見え方)。
//   記録 = docs/research/2026-11-04-hound-walk8-judder.md
let smooth: WalkCycleSmooth | undefined
export function houndWalk8Enabled(): boolean { return on }
export function setHoundWalk8(v: boolean): void {
  on = v
  setWalkCycleOverride('dream-hound', v ? { keys: HOUND_WALK8_KEYS, stridePx: HOUND_WALK8_STRIDE_PX, smooth } : null)
}
export function setHoundWalk8Smooth(v: WalkCycleSmooth | undefined): void {
  smooth = v
  if (on) setHoundWalk8(true)
}
setHoundWalk8(true)

// 飾りを揃えた8枚 (2026-11-05・開発版だけ ?houndWalkArt=unify)。配布版は上の8枚のまま。
//   今の8枚を元絵に、鎖・背の布・垂れ旗・たてがみ・王冠を t125 に揃える編集を Images 2.6 (Codex) にさせた7枚 (t125 は元のまま)。
//   脚・体の位置・大きさは元絵のまま (外接を元の絵に合わせた) なので、縮尺・横の置き場所・1周の距離は同じ値を使う。
//   絵 = public/sprites/bosses/dream-hound/walk-unify-1105/・記録 = docs/research/2026-11-05-hound-walk-unify.md
export const HOUND_WALK_UNIFY_DIR = 'walk-unify-1105'
export const HOUND_WALK_UNIFY_KEYS: readonly SpriteKey[] = HOUND_WALK8_KEYS.filter(k => k !== 'houndWalk8_t125')
export function setHoundWalkUnify(v: boolean): void {
  for (const k of HOUND_WALK_UNIFY_KEYS) setSpriteFileOverride('dream-hound', '', k, v ? `${HOUND_WALK_UNIFY_DIR}/${k}` : null)
}
